<template>
  <div class="infor">
    <v-row>
      <v-col col-md-3 class="infText">
        <v-row class="text">
          <a href="/" class="infText2">
            <img
              width="130"
              height="100"
              class="marginImg"
              src="../assets/olmed.png"
            /> </a
        ></v-row>
        <v-row class="textName">
          <p class="infText2">Ol-Reh</p>
        </v-row>
      </v-col>
      <v-col col-md-3 class="infText2">
        <p class="textTitle">
          Prywatna praktyka fizjoterapeutyczna <br />Aleksandra Skomudek
        </p>
      </v-col>
      <v-col col-md-3 class="infText2">
        <button class="btnColorComp" @click="copy">
          <v-icon size="28px" color="white">mdi-cellphone-android</v-icon>+48
          730 230 674
        </button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Navbar",

  data: () => ({
    menuItems: [
      { title: "Start", path: "/", icon: "fas fa-home" },
      { title: "O mnie", path: "/about", icon: "face" },
      { title: "Oferta", path: "/offers", icon: "lock_open" },
      { title: "Metody leczenia", path: "/metods", icon: "lock_open" },
      { title: "Kontakt", path: "/contact", icon: "lock_open" },
    ],
  }),
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
  methods: {
    copy() {
      this.$clipboard("+48 730 230 674");
      this.notify();
    },
    notify() {
      // this.$popup({ message: "Skopiowano numer" });
      this.$popup({
        message: "Skopiowano numer",
        delay: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application .grey--text {
  color: #414149 !important;
}
.infor {
  min-height: 200px;
  border-bottom: 1px solid #414149 !important;
}
.infText2 {
  margin: auto;
  align-content: center !important;
  text-align: center;
}
.infText {
  margin: auto;
  min-height: 200px;
  align-content: center !important;
  text-align: center;
}
.text {
  padding-top: 20px;
}
.textName {
  color: #414149;
  font-weight: 800;
  font-size: 25px;
  align-content: center;
}
.textTitle {
  color: #414149;
  font-weight: 800;
  font-size: 24px;
  text-align: center;
  padding-top: 20px;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  align-content: center;
  /* height: 150%; */
}
/* .col {
  text-align: center;
} */
.btnColorComp {
  color: $backgroundLightness !important;
  background-color: #453bff !important;
  font-weight: 700;
  height: 36px;
  min-width: 64px;
  padding: 0 8px;
  margin: 10px;
  border-radius: 4px;
}
.btnColorComp:hover {
  background-color: #45a4f9 !important;
  transition: all 0.5s ease-out;
}
</style>
